import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { FormGroup, Validators, FormArray } from '@angular/forms';

import { ModuleConfiguration } from '../customer.module.config';
import * as fromStore from '../store/reducers';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { AutoSaveFormBuilder } from '../../pillar/workspace/AutoSaveFormBuilder';
import { IAutoSave } from '../../pillar/workspace/IAutoSave';
import { Subject } from 'rxjs/Subject';
import { AutoSaveFormGroup } from '../../pillar/workspace/AutoSaveFormGroup';
import { GroupModel } from '../models/GroupModel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-group-workspace',
  templateUrl: './group-workspace.component.html',
  styleUrls: ['./group-workspace.component.scss']
})
export class GroupWorkspaceComponent implements OnInit, OnDestroy {
  group: GroupModel;
  key: string;
  loading$: Observable<boolean>;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  profileForm: FormGroup;
  accessRestrictionTypes = [];
  editPermission: string = 'CustomerModule.Groups:Edit';

  constructor(private store: Store<any>,
    private router: Router,
    private formBuilder: AutoSaveFormBuilder,
    private actions$: Actions,
    private route: ActivatedRoute) {
  }

  ngOnDestroy() {
    this.store.dispatch(new dashboardActions.ClearSelectionAction(ModuleConfiguration.moduleName, GroupModel));
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.loading$ = this.store.select(fromStore.getGroupListLoading);
    this.errors$ = this.store.select(fromStore.getGroupListErrors);

    this.route.params.take(1).subscribe(p => {
      this.key = p['key'];

      this.store.dispatch(new dashboardActions.GetSelectionAction(ModuleConfiguration.moduleName, GroupModel, { key: this.key }));
    });

    var updateTypes = [
      workspaceActions.updateModelSuccessType(ModuleConfiguration.moduleName, GroupModel, 'name'),
    ];
    this.actions$
      .takeUntil(this.destroyed$)
      .filter(a => updateTypes.indexOf(a.type) !== -1)
      .map((a: any) => a.payload)
      .subscribe((payload) => {
        payload.control.saveSuccess(payload.model);
      });
    this.store
      .select(fromStore.getGroupSelection)
      .takeUntil(this.destroyed$)
      .subscribe((v: GroupModel) => {
        if (!this.group && v) {
          this.group = v;
          this.initForms();
        }
      });
  }

  initForms(): void {
    this.profileForm = this.formBuilder.group({
      key: [''],
      name: this.formBuilder.control({ value: null, disabled: !this.group.canEdit },
        Validators.required,
        null,
        this.destroyed$,
        (control) => {
          this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, GroupModel, 'name', { key: this.key, model: control.value, control: control }));
        }),
      accessRestriction: this.formBuilder.control({ value: null, disabled: !this.group.canEdit },
        Validators.required,
        null,
        this.destroyed$,
        (control) => {
          this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, GroupModel, 'accessRestriction', { key: this.key, model: control.value, control: control }));
        })
    });

    this.profileForm.patchValue(this.group);
    this.profileForm.markAsPristine();
  }

  back() {
    this.router.navigateByUrl('/administration');
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/components/group-workspace.component.ts